let apiBaseUrl = "";
let socketUrl = "";
let aiBaseUrl = "";
let siteUrl = "";
let appStage = process.env.REACT_APP_STAGE;

if (appStage === "local") {
  siteUrl = "http://localhost:3030";
  apiBaseUrl = "http://10.25.27.69:8002/api/v1/";
  // apiBaseUrl = "http://127.0.0.1:8002/api/v1/";
  // apiBaseUrl = "https://drjob-dev.dreamztesting.com/api/v1/";
  // apiBaseUrl = "https://employer-api.drjobpro.net/api/v1/";
  apiBaseUrl = "https://employer-api-dev.drjobpro.net/api/v1/";
} else if (appStage === "dev") {
  siteUrl = "https://drjobui-dev.dreamztesting.com";
  apiBaseUrl = "https://employer-api-dev.drjobpro.net/api/v1/";
} else if (appStage === "164local") {
  siteUrl = "https://drjobui-local.dreamztesting.com";
  // apiBaseUrl = "https://drjob-local.dreamztesting.com/api/v1/";
  apiBaseUrl = "https://employer-api-dev.drjobpro.net/api/v1/";
} else if (appStage === "prod") {
  siteUrl = "https://drjobui-dev.dreamztesting.com";
  apiBaseUrl = "https://employer-api.drjobpro.net/api/v1/";
}

export const API_BASE_URL = apiBaseUrl;
export const SOCKETURL = socketUrl;
export const AI_BASE_URL = aiBaseUrl;
export const SITE_URL = siteUrl;
export const MEET_EXTERNAL_URL = "https://uat3.drjobpro.com/";
// export const EXTERNAL_URL = "https://uat3.drjobpro.com/";
export const EXTERNAL_URL = "https://www.drjobpro.com/";
export const EXTERNAL_AE_URL = "https://www.drjobs.ae/";
